import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./dependencyModal.html";
const depColumns = [{
  label: ' Name',
  fieldName: 'name',
  hideDefaultActions: true
}, {
  label: 'Developer Name',
  fieldName: 'developerName',
  hideDefaultActions: true
}, {
  label: 'Type',
  fieldName: 'componentType',
  hideDefaultActions: true
}, {
  label: 'Modified',
  fieldName: 'modifiedOn',
  hideDefaultActions: true,
  type: 'helpTextDisplay',
  typeAttributes: {
    label: {
      fieldName: 'modifiedOn'
    },
    tooltip: {
      fieldName: 'modifiedBy'
    }
  }
}];
class DependencyModal extends LightningElement {
  constructor() {
    super();
    this.data = [];
    this.columns = depColumns;
    this.name = void 0;
    this.developerName = void 0;
    this.preSelectedDepRows = void 0;
    this.selectedRows = [];
    this.closeModal = () => {
      const closeModalEvent = new CustomEvent('closemodal', {});
      this.dispatchEvent(closeModalEvent);
    };
    this.getSelectedName = event => {
      const {
        detail: {
          selectedRows
        }
      } = event;
      this.selectedRows = selectedRows;
    };
    this.addSelectedDependencies = () => {
      const dependencyRowsEvent = new CustomEvent('selecteddependenciesrows', {
        detail: this.selectedRows,
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(dependencyRowsEvent);
      this.closeModal();
    };
  }
}
_registerDecorators(DependencyModal, {
  publicProps: {
    data: {
      config: 0
    },
    name: {
      config: 0
    },
    developerName: {
      config: 0
    },
    preSelectedDepRows: {
      config: 0
    }
  },
  fields: ["columns", "selectedRows", "closeModal", "getSelectedName", "addSelectedDependencies"]
});
export default _registerComponent(DependencyModal, {
  tmpl: _tmpl
});